import { request } from '@luna/api';
import { getEnv } from '@luna/env';

import type { Financing } from './types/aggregationService';

export const fetchFinancingAccount = (id: string): Promise<Financing> => {
    const { apiGatewayUrl } = getEnv();

    return request<Financing>(
        `${apiGatewayUrl}product/public/financings/${encodeURIComponent(id)}`,
    );
};
